import script from "./AssignNode.vue?vue&type=script&lang=js"
export * from "./AssignNode.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__